import React, { useContext, useEffect, useState } from 'react'
import { LocaleContext } from '../../contexts/LocaleContext';
import { params } from '../../config/params';
import { searchParams } from '../../config/searchParams';
import { urlConfig } from '../../config/baseUrl';
import InLinneLoading from '../../components/common/InlineLoading';
import Pagination from '../../components/Pagination';
import { toast } from '../../services/toastService';
import Loading from '../../components/common/Loading';
import { Link } from 'react-router-dom';
import DeleteConfirmation from '../../components/DeleteConfirmation';
import { transactionService } from '../../services/transactionService';

const Transactions = () => {
  const { t, lang } = useContext(LocaleContext);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [data, setData] = useState([]);

  useEffect(() => {
    setLoading(true);
    getAllAsync();
  }, []);

  const getAllAsync = async () => {
    try {
      var data = await transactionService.getAllAsync(params);
      setData(data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  const getAllSearchAsync = async (signal) => {
    try {
      var data = await transactionService.getAllSearchAsync(searchParams, signal);
      setData(data);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };
  // 🟢 Search effect with debounce & cancel
  useEffect(() => {
    if (search.trim().length < 2) {
      params.pageNumber = 1;
      getAllAsync(); // reset to default if search is cleared
      return;
    }

    const controller = new AbortController(); // cancel token
    const delay = setTimeout(() => {
      searchParams.search = search.trim(); // update global params
      searchParams.pageNumber = 1; // reset page to 1 on search
      getAllSearchAsync(controller.signal);
    }, 400); // debounce time

    return () => {
      controller.abort(); // cancel previous request
      clearTimeout(delay); // clear debounce
    };
  }, [search]);
  const onPageChange = async (pageNumber) => {
    setLoading(true);
    if (!search) {
      params.pageNumber = pageNumber;
      getAllAsync();
      return;
    }
    searchParams.pageNumber = pageNumber;
    await getAllSearchAsync();
  };
  
  return (
    <>
      {loading && <Loading />}
      <section className="section-categories">
        <div className="default-heading">{t("transactions")}</div>
        <section className="section-grid">
          <div className="grid-card">
            <div className="gird-card-header">
              <strong>{t("transactionsManagement")}</strong>
              <p></p>
            </div>
            <div className="grid-card-body">
              <div className="table-header">
                <div className="table-header-icons hidden">
                  <div className="icon-box">
                    <i className="fas fa-file-pdf"></i>
                  </div>
                  <div className="icon-box">
                    <i className="fas fa-file-excel"></i>
                  </div>
                  <div className="icon-box">
                    <i className="fas fa-print"></i>
                  </div>
                </div>
                <div className="table-search">
                  <div className="input-icon input-icon-width">
                    <input
                      type="text"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                      className="form-control input-search"
                      placeholder={t("search")}
                    />
                    <i className="fas fa-search"></i>
                  </div>
                </div>
              </div>
              <div className="table-delete-option mt-3">
                <b>{t("allTransactions")}</b>
              </div>
              <div className="my-table">
                <table className="table">
                  <thead>
                    <tr>
                      <th>{t("provider")}</th>
                      <th>{t("customer")}</th>
                      <th>{t("trip")}</th>
                      <th>{t("date")}</th>
                      <th>{t("tranRef")}</th>
                      <th>{t("total")}</th>
                      <th>{t("providerCost")}</th>
                      <th>{t("appCost")}</th>
                      <th>{t("paymentMethod")}</th>
                      <th>{t("cardType")}</th>
                      <th>{t("status")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.items?.map((item,index) => (
                      <tr key={index}>
                        <td>{item.provider}</td>
                        <td>{item.customer}</td>
                        <td>{item.trip?.[lang]}</td>
                        <td>{item.transactionTime.toDate()}</td>
                        <td>{item.tranRef}</td>
                        <td>{item.tranTotal}</td>
                        <td>{item.providerCost}</td>
                        <td>{item.appCost}</td>
                        <td>{item.paymentMethod}</td>
                        <td>{item.cardType}</td>
                        <td>{item.status}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="grid-footer">
              {data && (
                <Pagination
                  t={t}
                  pageNumber={data.pageNumber}
                  totalPages={data.totalPages}
                  hasNextPage={data.hasNextPage}
                  hasPreviousPage={data.hasPreviousPage}
                  onPageChange={onPageChange}
                />
              )}
            </div>
          </div>
        </section>
      </section>
    </>
  );
};

export default Transactions